import React from "react";

import { actions } from "frequencyscreen_v_dbinder";
import { NamespacesConsumer, translate } from "react-i18next";
import { withRouter } from "react-router-dom";
import { AlertProps, languageOptions, Permissions } from "../../utils";
import { AlertContext, LoggerContext } from "../../contexts";
import IDMPANEL from "idmpanel-pkg";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../config";
import cookie from "react-cookies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as ALL from "../../components";
import { Modal } from "qdm-component-library";
import moment from "moment";
import {
  Paper,
  Divider,
  Box,
  Grid,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import qdmstyles from "./styles.json";
import "./index.css";

import makeStyles from "@material-ui/core/styles/makeStyles";

var aes256 = require("aes256");

const useStyles = makeStyles((theme) => ({
  number: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
    },
  },
  schedule: {
    color: theme.palette.text.primary,
  },
  paper: {
    color:"#6a7888"
  },
  childschedule_background: {
    backgroundColor: theme.palette.background.table
  },
  childschedule: {
    color: theme.palette.primary.light
  },
  notchedOutline:{
    borderColor:theme.palette.border.textField
  },
  autocomplete: {
    "& .App1-MuiOutlinedInput-notchedOutline":{
      borderColor:theme.palette.border.textField
    },
   },
}));

function Schedulelines(props) {
  
  const dispatch = useDispatch();

  const classes = useStyles();
  const { setSnack } = React.useContext(AlertContext);
  const [error, setError] = React.useState({});

  const frequencymaster_uom_dropdownData = useSelector(
    (state) =>
      state?.addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer
        ?.frequencymaster_uom_dropdown_OE55Y?.data
  );
  const base_frequency_dropdown = useSelector(
    (state) =>
      state?.EditNewFrequency_orgbase_frequency_dropdownReducer
        ?.base_frequency_dropdown?.data
  );
  const scheduleLine_day_dropdown = useSelector(
    (state) => state?.schedule_line_day_dropdownReducer?.schedule_line_day?.data
  );

  const contextType = React.useContext(LoggerContext);
  const [state, setState] = React.useState({
    permissionData: null,
    schedulelines_spv7r: null,
    schedulelines_ogv4s: null,
    schedulelines_ckuy1: null,
    schedulelines_arjlu: null,
    schedulelines_ehoh3: null,
  });

  React.useEffect(() => {
    setState({
      permissionData: null,
      schedulelines_spv7r: null,
      schedulelines_ogv4s: null,
      schedulelines_ckuy1: null,
      schedulelines_arjlu: null,
      schedulelines_ehoh3: null,
    });
  }, [props.propsState.addnewfrequency_org_yknsy]);

  const changeState = (key, value) => {
    setState({
      ...state,
      [key]: value,
    });
  };

  const onchange_spv7r = (e, index) => {
    
    let bigvalue = getBigValue();
    // !e.target.value || bigvalue
    if (
      // !e.target.value ||
      // (bigvalue < Number(e?.target?.value) && Number(e?.target?.value) <= 7)
      // bigvalue < Number
      true
    ) {
      //  (
      //  (bigvalue < Number(e?.target?.value) && !bigvalue) ||
      //   (
      //     bigvalue < Number(e?.target?.value) &&
      //     bigvalue < Number(e?.target?.value) <= 7)
      //   // bigvalue <
      // )
      setState({ ...state, schedulelines_spv7r: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];
      stateValue[index] = {
        ...stateValue[index],
        schedulelines_spv7r: e?.target?.value,
      };
      props.setFun(stateValue);
    }
  };
  const onchange_time = (e, index) => {
    
    setState({
      ...state,
      schedulelines_time: moment(e).format("HH:mm"),
    });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      schedulelines_time: moment(e).format("HH:mm"),
    };
    props.setFun(stateValue);
  };
  const onchange_day = (e, value, index) => {
    
    setState({ ...state, schedulelines_day: value });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      schedulelines_day: value,
    };
    props.setFun(stateValue);
  };
  const getBigValue = () => {
    
    let fromDay =
      props?.statevalue
        ?.map((val) => Number(val?.schedulelines_spv7r ?? 0))
        ?.filter((val) => val) ?? [];
    let toDay =
      props?.statevalue
        ?.map((val) => Number(val?.schedulelines_ogv4s ?? 0))
        ?.filter((val) => val) ?? [];
    let arr = [...fromDay, ...toDay];
    arr = arr.sort();
    let len = arr.length;
    return len > 0 ? arr[len - 1] : 0;
  };
  const onchange_ogv4s = (e, index) => {
    
    let bigvalue = getBigValue();
    if (
      // !e.target.value ||
      // (Number(e.target.value) === bigvalue &&
      //   Number(props?.statevalue[index].schedulelines_ogv4s) === bigvalue) ||
      // (bigvalue <= Number(e?.target?.value) && Number(e?.target?.value) <= 7)
      true
    ) {
      //  (
      //   !e.target.value ||
      //   (Number(e.target.value) === bigvalue &&
      //     Number(props?.statevalue[index].schedulelines_ogv4s) === bigvalue) ||
      //   (Number(e?.target?.value) && Number(e?.target?.value) <= 7)
      //   // bigvalue <
      // )
      if (e.target.value <= state.schedulelines_spv7r) {
        setError({ ...error, schedulelines_ogv4s: true });
      } else {
        setError({ ...error, schedulelines_ogv4s: false });
      }
      setState({ ...state, schedulelines_ogv4s: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

      stateValue[index] = {
        ...stateValue[index],
        schedulelines_ogv4s: e?.target?.value,
      };
      props.setFun(stateValue);
    }
  };

  const onchange_ckuy1 = (e, v, index) => {
    
    // if (props.propsState.addnewfrequency_org_oqc17) {
    setState({ ...state, schedulelines_ckuy1: v });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      schedulelines_ckuy1: v,
    };
    props.setFun(stateValue);
    // }
  };
  const onchange_arjlu = (e, index) => {
    if (e.target.value.length <= 100) {
      setState({ ...state, schedulelines_arjlu: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

      stateValue[index] = {
        ...stateValue[index],
        schedulelines_arjlu: e?.target?.value,
      };
      props.setFun(stateValue);
    }
  };

  const valueValidate = () => {
    const Day_Based =
      props?.propsState?.addnewfrequency_org_wkley &&
      (props.statevalue?.length ?? 1) <
      Math.floor(props?.propsState?.addnewfrequency_org_wkley) &&
      props?.propsState?.addnewfrequency_org_yknsy?.display === "Day Based";
    const Detail =
      props?.propsState?.addnewfrequency_org_tndul &&
      (props.statevalue?.length ?? 1) <
      Math.floor(props?.propsState?.addnewfrequency_org_tndul) &&
      props?.propsState?.addnewfrequency_org_yknsy?.display === "Detail";
    const Interval =
      props?.propsState?.addnewfrequency_once_every &&
      (props.statevalue?.length ?? 1) <
      Math.floor(props?.propsState?.addnewfrequency_once_every) &&
      props?.propsState?.addnewfrequency_org_yknsy?.display === "Interval";
    const Sequential =
      props?.propsState?.addnewfrequency_org_vdyg1 &&
      (props.statevalue?.length ?? 1) <
      Math.floor(props?.propsState?.addnewfrequency_org_vdyg1) &&
      props?.propsState?.addnewfrequency_org_yknsy?.display === "Sequential";
    const User_Defined =
      props?.propsState?.addnewfrequency_org_tndul &&
      (props.statevalue?.length ?? 1) <
      Math.floor(props?.propsState?.addnewfrequency_org_tndul) &&
      props?.propsState?.addnewfrequency_org_yknsy?.display === "User Defined";
    return Day_Based || Detail || Interval || Sequential || User_Defined;
  };

  const onclick_ehoh3 = (e, index) => {
    
    // if (props?.propsState?.addnewfrequency_org_yknsy?.display === "Interval") {
    //   setState({ ...state, schedulelines_ehoh3: e?.target?.value });
    //   let stateValue = props.statevalue;
    //   stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];
    //   props.setFun([...stateValue, {}]);
    // } else {
    if (props.statevalue && valueValidate()) {
      setState({ ...state, schedulelines_ehoh3: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];
      props.setFun([...stateValue, {}]);
    }
  };

  React.useEffect(() => {
    /// initializing transalation
    if (localStorage.defaultLng) {
      const { i18n } = props;
      i18n.changeLanguage(localStorage.defaultLng);
    }
    /// setlogger && dispatch of all events

    /// fetch all permission
  }, []);

  ///fetching all permission

  React.useEffect(() => { }, [state]);

  const datefilter = () => {
    var arr = [];
    const val = props?.statevalue?.map((p) => {
      if (p.schedulelines_day?.display) {
        return arr.push(p.schedulelines_day?.display);
      }
    });
    return scheduleLine_day_dropdown?.result.filter((l) => {
      if (!arr.includes(l.display)) {
        return { l };
      }
    });

    // scheduleLine_day_dropdown?.result
  };
  return (
    <NamespacesConsumer>
      {(t, { i18n }) => (
        <React.Fragment>
          <Paper key={"0"} id={"m1Wby"} elevation={"1"}
            style={qdmstyles.mWby}
            className={classes.childschedule_background}
          >
            <Box
              key={"0"}
              id={"DGwzy"}
              m={"1"}
              component={"div"}
              style={qdmstyles.DGwzy}
            >
              <Grid
                key={"0"}
                id={"Sqq4d"}
                container={true}
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                item={true}
                lg={"12"}
                style={qdmstyles.Sqqd}
              >
                <Grid
                  key={"0"}
                  id={"kWbw8"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    key={"0"}
                    id={"WSZqV"}
                    align={"inherit"}
                    display={"initial"}
                    variant={"body1"}
                    className={classes.schedule}
                    children={t("frequency.addScreen.scheduleLines")}
                    style={qdmstyles.WSZqV}
                  ></Typography>
                </Grid>
                <Grid
                  key={"1"}
                  id={"hBm1i"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Button
                    key={"0"}
                    onClick={(e) => onclick_ehoh3(e)}
                    id={"EhOH3"}
                    variant={"text"}
                    color={'primary'}
                    children={"+ Add New"}
                    aliasName={"addnewSch"}
                  ></Button>
                </Grid>
              </Grid>
              <Grid
                key={"1"}
                id={"dHOGr"}
                container={true}
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                item={true}
                lg={"12"}
                spacing={"2"}
                md={"12"}
                sm={"12"}
                xl={"12"}
                xs={"12"}
                onLoad={(e) => props.setFun(props?.statevalue ?? [{}])}
              >
                {(props?.statevalue ?? [{}])?.map((data, index) => {
                  return (
                    <React.Fragment key={data?.schedulelines_ckuy1?.code ?? index}>
                      <Grid
                        key={"0"}
                        id={"RXT97"}
                        container={true}
                        direction={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        xs={"12"}
                        xl={"12"}
                        sm={"12"}
                        md={"12"}
                        lg={"12"}
                        style={qdmstyles.RXT}
                      >
                        {(props?.propsState?.addnewfrequency_org_yknsy
                          ?.display ?? null) === "Day Based" && (
                            <Grid
                              key={"6"}
                              id={"FTOds"}
                              container={false}
                              direction={"row"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              lg={"3"}
                              item={true}
                              md={"4"}
                              sm={"3"}
                              xl={"3"}
                              xs={"3"}
                              style={qdmstyles.nCJAx}
                            >
                              <Typography
                                key={"0"}
                                id={"h9zkG"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                className={classes.childschedule}
                                children={"Day"}
                                style={{
                                  fontSize: 12,
                                }}
                              ></Typography>
                              <Autocomplete
                                id={"fW4qT"}
                                style={qdmstyles?.fWqT}
                                value={
                                  data?.schedulelines_day ?? null
                                }
                                // onLoad={() =>
                                //   this.setState({
                                //     addnewfrequency_org_fw4qt:
                                //       this.state?.addnewfrequency_org_fw4qt ?? null,
                                //   })
                                // }
                                classes={{
                                  paper: classes.paper
                                }}
                                className={classes.autocomplete}
                                getOptionLabel={(option) => option?.["display"]}
                                options={
                                  datefilter() // scheduleLine_day_dropdown?.result
                                }
                                onChange={(e, newvalue) =>
                                  onchange_day(e, newvalue, index)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                  />
                                )}
                              />
                            </Grid>
                          )}
                        {(props?.propsState?.addnewfrequency_org_yknsy
                          ?.display ?? null) === "User Defined" && (
                            <Grid
                              key={"0"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"1"}
                              md={"1"}
                              sm={"1"}
                              style={{ padding: "0px 11px 0px 0px" }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                className={classes.childschedule}
                                display={"initial"}
                                variant={"body1"}
                                children={"From Day"}
                                style={qdmstyles.YMc}
                              ></Typography>
                              <TextField
                                key={"1"}
                                onChange={(e) => onchange_spv7r(e, index)}
                                // data?.schedulelines_ogv4s
                                InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                                inputProps={{ maxLength: 10 }}
                                id={"saQ6c"}
                                label={""}
                                placeholder={""}
                                value={data?.schedulelines_spv7r ?? ""}
                                type={"number"}
                                variant={"outlined"}
                                margin={"dense"}
                                size={"small"}
                                aliasName={"fromDay"}
                                className={classes.number}
                              ></TextField>
                            </Grid>
                          )}{" "}
                        {(props?.propsState?.addnewfrequency_org_yknsy
                          ?.display ?? null) === "Detail" && (
                            <Grid
                              key={"1"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"2"}
                              md={"2"}
                              sm={"2"}
                              style={{ paddingRight: "16px" }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                className={classes.childschedule}
                                display={"initial"}
                                variant={"body1"}
                                children={"Time"}
                                style={qdmstyles.mMSJ}
                              ></Typography>
                              <DatePicker
                                id={`DatePicker`}
                                selected={
                                  data?.schedulelines_time
                                    ? new Date(
                                      moment(
                                        data?.schedulelines_time,
                                        "HH:mm"
                                      )
                                    )
                                    : ""
                                }
                                //  selected={props?.value ? new Date(props?.value) : null}
                                // onChange={(e) => console.log(e)}
                                onChange={(e) => onchange_time(e, index)}
                                // showTimeSelect
                                // showTimeSelectOnly
                                // timeIntervals={30}
                                // timeCaption="Time"
                                // dateFormat="H:mm aa"
                                timeFormat={"HH:mm"}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={5}
                                timeCaption="Time"
                                dateFormat={"HH:mm"}
                                placeholderText="Time"
                              />
                              {/* <TextField
                              key={"1"}
                              fullWidth
                              onChange={(e) => onchange_time(e, index)}
                              // inputProps={{ maxLength: 5 }}
                              id={"saQ6c"}
                              // style={{ width: '70px' }}
                              // label={"Time"}
                              type={"time"}
                              value={moment
                                .unix(data?.schedulelines_time)
                                .format("hh:mm:ss")}
                              // value={state?.schedulelines_time?.replace(/(\d{2})(\d{2})/, '$1' + ':' + '$2')}
                              placeholder={"Time"}
                              variant={"outlined"}
                              margin={"dense"}
                              size={"small"}
                              aliasName={"today"}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className={classes.number}
                            ></TextField> */}
                            </Grid>
                          )}{" "}
                        {(props?.propsState?.addnewfrequency_org_yknsy
                          ?.display ?? null) === "User Defined" && (
                            <Grid
                              key={"1"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"1"}
                              md={"1"}
                              sm={"1"}
                              style={{ paddingRight: "16px" }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                className={classes.childschedule}
                                display={"initial"}
                                variant={"body1"}
                                children={"To Day"}
                                style={qdmstyles.mMSJ}
                              ></Typography>
                              <TextField
                                key={"1"}
                                onChange={(e) => onchange_ogv4s(e, index)}
                                inputProps={{ maxLength: 10 }}
                                id={"saQ6c"}
                                InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                                label={""}
                                placeholder={""}
                                value={data?.schedulelines_ogv4s ?? ""}
                                // error={error?.schedulelines_ogv4s}
                                type={"text"}
                                variant={"outlined"}
                                margin={"dense"}
                                size={"small"}
                                aliasName={"today"}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className={classes.number}
                              ></TextField>
                            </Grid>
                          )}{" "}
                        {((props?.propsState?.addnewfrequency_org_yknsy
                          ?.display ?? null) === "Day Based" ||
                          (props?.propsState?.addnewfrequency_org_yknsy
                            ?.display ?? null) === "User Defined" ||
                          (props?.propsState?.addnewfrequency_org_yknsy
                            ?.display ?? null) === "Interval" ||
                          (props?.propsState?.addnewfrequency_org_yknsy
                            ?.display ?? null) === "Sequential") && (
                            <Grid
                              key={"2"}
                              id={"kstWr"}
                              container={false}
                              direction={"column"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"3"}
                              md={"3"}
                              sm={"3"}
                              xl={"3"}
                              xs={"3"}
                              style={qdmstyles.JNtz}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                className={classes.childschedule}
                                display={"initial"}
                                variant={"body1"}
                                children={"Base Frequency"}
                                style={qdmstyles.YpPoE}
                              ></Typography>
                              <Autocomplete
                                id={"fW4qT"}
                                style={qdmstyles?.fWqT}
                                // getOptionLabel={(option) => option?.val}
                                getOptionLabel={(option) => option.val}
                                classes={{
                                  paper: classes.paper
                                }}
                                className={classes.autocomplete}
                                value={data?.schedulelines_ckuy1 ?? {}}
                                options={base_frequency_dropdown?.result?.map(
                                  (v) => {
                                    return {
                                      val: v?.freqcode + " " + v?.shortdesc,
                                      code: v?._id,
                                    };
                                  }
                                )}
                                onChange={(e, newvalue) =>
                                  onchange_ckuy1(e, newvalue, index)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                  />
                                )}
                              />
                            </Grid>
                          )}{" "}
                        <Grid
                          key={"3"}
                          id={"kstWr"}
                          container={false}
                          direction={"column"}
                          justifyContent={"flex-start"}
                          alignItems={"flex-start"}
                          item={true}
                          lg={"5"}
                          md={"5"}
                          sm={"5"}
                          xl={"5"}
                          xs={"5"}
                          style={qdmstyles.PeVKs}
                        >
                          <Typography
                            key={"0"}
                            id={"Y8M1c"}
                            align={"inherit"}
                            color={"text"}
                            className={classes.childschedule}
                            display={"initial"}
                            variant={"body1"}
                            children={"Remarks"}
                            style={qdmstyles.uLu}
                          ></Typography>
                          <TextField
                            key={"1"}
                            onChange={(e) => onchange_arjlu(e, index)}
                            id={"saQ6c"}
                            // label={""}
                            // placeholder={"Remarks"}
                            color={"primary"}
                            type={"text"}
                            variant={"outlined"}
                            InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                            value={data?.schedulelines_arjlu ? data?.schedulelines_arjlu : ""}
                            margin={"dense"}
                            inputProps={{ maxLength: 100 }}
                            size={"small"}
                            fullWidth={true}
                            aliasName={"remarks"}
                          ></TextField>
                        </Grid>
                        {props?.propsState?.addnewfrequency_org_yknsy &&
                          index !== 0 ? (
                          <img
                            width="18px"
                            height="18px"
                            style={{
                              margin: "0px 22px -13px",
                              cursor: "pointer",
                            }}
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAh1BMVEX/////AAD/WVn/oKD/p6f/5ub/9vb/xcX/kZH/Kir/LS3/VVX/vb3/rKz/1dX/RET/TEz/y8v/s7P/ZGT/9fX/Ozv/Njb/t7f/3Nz/m5v/lZX/hIT/7e3/Ghr/aGj/0ND/Pz//b2//eXn/R0f/6Oj/fX3/Gxv/Dg7/c3P/i4v/goL/IyP/ZmaQsKNcAAAFP0lEQVR4nO2da3OiPBiGiyK2VbRuFVEs4mm12/3/v+/18M5OhztqEkMS6H19dELmuQRCznl6qpBou+xP4zgMw/YVwjCedtNFlUFUx3iafwWSvM1S1+Eqs81eZPUutPquQ1ais1PTO5NMXYctz0zD70SxdB25HINCU/DIZ+Q6eglCfb8jm47r+O+yekjwiOdP6rj3qGAQeF3gRG+PCwaBz98NA3fwRNe1x1VyM4JB4GsN57FS9DuFnx+NgTHBINi5lhERDQ0aevkqmntGT7y41kEio4JBELoWAszewiDYe1fYXGkO7nufcXc0GKSdC+mFwYnlqNtv767V09uujUr0hVH+bm/vXzoSV4Qmnt3Ed1GQa8kOmFioOKo2YkUWe0GIc+nLlyLDrMJ41RE9pH8UrhcpvlYWrQ4HDLBQykBUFHtVO319+DUSNEviamLVYoHhtRSz6GIWq0pi1WOE4Sm31Cdev4j4Fu3HqnnM8V+qIlRNniG4N+U8BMWpR+MZ2MUt/y38Bxp61LOI3RcaHWZo6NHnogXBafSXfdTLUKONjq0TGpokuonoKb19hSgTNBzcu8QEnfb6vTccTpLJ6w2wZfF1K7kYyCN4uZE6mSTF8K2Xfz7WZzXWGem0TfKAY/rbdfRyPGvfwcR16LLotkIENUVP+VCuBV+ozS3UHXNMXYetwEHLcOo6bAUSLUPdOSNO0DLMXEetglZTcu06ahW0mpLNN1y5jloFGtLQf7QMjc2OsYGKYTcZntnUpOl0obgEXcgMJtSpsobIVN/E49V1gYb1N5zQkIbe03zDQsJQMKBeIzY0/BGGgnkVNUJm/oBwjllt6DX+HsoYNv8emlxUYB+Z9uE2O7I+rPMjrTMwwrtpOQIa5cX55795/ne1PuyOgeuNs8EYlLPZuzCB0dAiMH8MYUa4oZV8NLQHDXWhoT1oqAsN7UFDXWhoDxrqQkN7VGUIK5KgVTYelMA56OUUA1g/uyinwJHrzd1I9ICtBCBf6GPdl1N0yimCz3KSdjkF9gzej8SaIWwYgIYwdRmWh2GvEg1pSEMa0pCGNKQhDWlIQxrSkIY0pCENaUhDGtKQhjSkIQ1p6Lsh7GUMI6+2DO+P1eoBI6+/HBlGYGho63YYPachDWlIQxrSkIY0pCENaUhDGtKQhjSk4Q83hH3bm2Y4piENafgP2F6DhjSkIQ0fBc7J8cfQ0GpWGtKQhjSkIQ1rZIht/KYZjuF4vcYZftGQhrKGYeMN2zSkIQ1pSEMa0pCGNNQ2XMCe7I0z/Ph5hkszhu/lfGfeGA5oSEMa0pCG3hrOG28IwVky3MKZPjSk4TVD2MYZDD/uG2rsBW3PMCunWPRLwDyXqJyiD1t+d8opoFqNf5M1Q0vQUBswXJvJV5mUhrr8QMOVmXyVwcMnqzLMzeSrjD3DdzP5KoNHpFZlKHPYZxXggdpVGcocK1wFU2uGSWQmY1Via4YBngBjhZ09QzeFqeAcX0N93ivMGfr1LbCAeXtBgGcSaYFFmKCrpnJSgaDMOeNSQAfQkZ6hv08WaB+f0DvfWMBMlHtQ5Icsy+YnZhfa3whjRb5f/H9+57yfs2y9wqLgjCnBp4U4f+dAR4g+uWsXMQZfFD/PWzf6zTq4thFhtKzburYRYPAtPAHdtc55NV05vlJeu8P49ziCPT7dAuvJH0dULXRHJRXjLazncAeM0ZrBnwe1gkf0wnjtWu3Ml6H1zUJEDSnb5OMKBY/ljevbmBja/vkGnZVLP2Mtwpukc9jNyA6rvr1Ovs7oVxy2LRLG/XShFep/9Fi4XhXtpEkAAAAASUVORK5CYII="
                            onClick={(e) => props.Delete(e, index)}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
            </Box>
          </Paper>
        </React.Fragment>
      )
      }
    </NamespacesConsumer >
  );
}

export default withRouter(translate()(Schedulelines));
